import React from 'react';
import { Table } from 'antd';
import { ManageCookiesButton } from 'components/Page/Footer/Footer.styled';
import { Container, Flex, Li, Link, MarginBox, Paragraph, Section, SectionHeader, Text, Ul } from 'UI';

export const CookiesTR = () => {
  return (
    <Container size={'md'} alignText={'justify'}>
      <MarginBox mt={15} />
      <Flex justify={'center'}>
        <Text type={'h5_bold'}>ÇEREZ POLİTİKASI</Text>
      </Flex>
      <MarginBox mt={30} />
      <Paragraph>
        Renault olarak, çevrimiçi verilerinizin güvenliğini 6698 sayılı Kişisel Verilerin Korunması Kanunu
        (&quot;KVKK&quot;) ve sair mevzuat hükümlerine uygun şekilde sağlamaya öncelik veriyoruz. Web sitemiz, size
        yüksek kaliteli, akıcı ve kişiselleştirilmiş bir deneyim sağlamak için çerezler kullanmaktadır.
      </Paragraph>
      <Paragraph>
        Çerez yönetimi aracımızı kullanarak çerezlere ilişkin tercihlerinizi istediğiniz zaman yeniden
        değerlendirebilirsiniz:{' '}
        <ManageCookiesButton $color={'brand_alt'}>
          <button id="ot-sdk-btn" className="ot-sdk-show-settings">
            SEÇİMLERİMİ YÖNET
          </button>
        </ManageCookiesButton>
        .
      </Paragraph>
      <Section>
        <SectionHeader title={'1. BİZ KİMİZ?'} />
        <Paragraph>
          Renault SAS tarafından yayımlanan{' '}
          <Link to={'https://rpartstore.renault.com'} external newTab>
            https://rpartstore.renault.com
          </Link>{' '}
          web sitesine hoş geldiniz. Renault SAS, cihazınıza yerleştirilen veya okunan çerezler ve diğer izleyiciler
          üzerinden toplanan kişisel verileriniz için veri sorumlusu sıfatıyla hareket etmektedir (ve bundan böyle
          &quot;biz&quot;, &quot;bize/bizi&quot;, &quot;bizim&quot; olarak anılacaktır).
        </Paragraph>
      </Section>
      <Section>
        <SectionHeader title={'2. ÇEREZ NEDİR?'} />
        <Paragraph>
          Çerez, kullanılan cihazın türüne bakılmaksızın (bilgisayar, akıllı telefon, dijital okuyucu, internete bağlı
          video oyun konsolu vb.) bir web sitesini ziyaret ederken, bir mobil uygulamayı kullanırken, bir e-posta
          okurken, bir yazılımı yüklerken veya kullanırken depolanan ve okunan küçük bir bilgisayar dosyası, bir
          izleyicidir.
        </Paragraph>
        <Paragraph>
          Bir web sitesine girildiğinde, çerezler kullanıcının tarayıcısına bilgi gönderebilir ve tarayıcının orijinal
          web sitesine geri bilgi göndermesine olanak tanıyabilir (örneğin, bir oturum kimliği veya dil seçimi).
        </Paragraph>
        <Paragraph>
          Çerezler sizi doğrudan tanımlamamıza olanak vermez, yalnızca cihazınız, tarayıcınız, kullandığınız web sitesi
          veya uygulama ile etkileşimleriniz ve bazı durumlarda coğrafi konumunuz hakkında belirli bilgileri toplamamızı
          sağlar.
        </Paragraph>
        <Paragraph>
          Cihazların size ait olduğunu belirlemek için kullanılan teknolojiler, yüksek olasılıkla birden fazla
          cihazınızı birbirine bağlayabilir.
        </Paragraph>
      </Section>
      <Section>
        <SectionHeader title={'3. BU WEB SİTESİNDE ÇEREZLER NE AMAÇLA VE HANGİ HUKUKİ SEBEPLE KULLANILIR?'} />
        <Paragraph>Bu site farklı türde çerezler kullanır.</Paragraph>
        <SectionHeader title={'Zorunlu/Teknik Çerezler'} />
        <Paragraph>
          Bu çerezler, elektronik iletişimi sağlamak veya kolaylaştırmak (bağlantı hatalarının tespiti, bağlantı
          noktalarının belirlenmesi, web sitesi güvenliği vb.) veya özel olarak talep edebileceğiniz çevrimiçi iletişim
          hizmetlerini (ekran görüntüleme tercihleri, formlara ve (söz konusu olması halinde) alışveriş sepetine girilen
          bilgilerin kaydedilmesi, web sitemizdeki kullanıcı hesabınıza, sohbetlere veya chatbot&apos;a erişmek vb.)
          sağlamak amacıyla tasarlanmıştır.
        </Paragraph>
        <Paragraph>Bu çerezler web sitemizin düzgün çalışması için gereklidir.</Paragraph>
        <Paragraph>
          Bu çerezlerin kullanımına itiraz etmeniz mümkün olmayıp, web sitemizdeki hizmetler bu çerezlere dayalı
          olduğundan bunlar için rızanız gerekli değildir.
        </Paragraph>
        <Paragraph>
          Zorunlu/teknik çerezleriniz, KVKK&apos;nın 5/2 (f) maddesi uyarınca temel hak ve özgürlüklerinize zarar
          vermemek kaydıyla, veri sorumlusunun meşru menfaatleri için veri işlemesinin zorunlu olması hukuki sebebi
          uyarınca işlenmektedir.
        </Paragraph>
        <SectionHeader title={'Analitik Çerezler'} />
        <Paragraph>
          Bu çerezler, web sitesi trafiğini analiz etmek, kullanıcı deneyimini analiz etmek veya yalnızca sitedeki
          ziyaretlerin akışına ilişkin toplu göstergeler (örn. dil seçimi, ziyaret edilen önceki sayfa, ziyaretin zaman
          damgası, çerez seçimi) toplamak için tasarlanmıştır.
        </Paragraph>
        <Paragraph>
          Bu çerezler, ziyaret edilen sayfalar, ziyaret edilen sayfalarda geçirilen süre, bu sayfaları ziyaret etmek
          için kullandığınız tarayıcı, web sitemizdeki sohbet veya chatbot kullanımınız vb. ile ilgili verileri
          işleyebilir.
        </Paragraph>
        <Paragraph>
          Bu çerezler tarafından toplanan veriler, ürünlerimize ve hizmetlerimize yönelik potansiyel ilgi alanlarınızı
          ve tercihlerinizi analiz etmek amacıyla algoritmalar ve profiller oluşturmak için de kullanılabilir. Bu
          verileri müşteri veritabanımızdaki bilgiler gibi diğer bilgilerle birleştirebiliriz.
        </Paragraph>
        <Paragraph>Bu çerezlerin kullanımı ve saklanması genel olarak sizin izninize tabidir.</Paragraph>
        <Paragraph>
          Belirli koşullar altında bu çerezler, örneğin çerezlerin amacının yalnızca ziyaret ettiğiniz içerikleri analiz
          etmek olması durumunda, izniniz olmadan yerleştirilebilir/okunabilir.
        </Paragraph>
        <Paragraph>
          Analitik çerezleriniz, KVKK&apos;nın 5/1 maddesi uyarınca açık rızanızın bulunması hukuki sebebi uyarınca
          işlenmektedir.
        </Paragraph>
      </Section>
      <Section>
        <SectionHeader title={'4. BU WEB SİTESİNDE HANGİ ÇEREZLER KULLANILIYOR?'} />
        <Paragraph>
          Ekteki liste, bu web sitesi tarafından saklanan ve/veya kullanılan tüm çerezlerin listesini ve bunların temel
          özelliklerini içerir. Web sitemizde kullanılan çerezler, bazı hizmet sağlayıcılarımızın Türkiye dışında
          bulunması nedeniyle yurt dışına aktarılabilmektedir. Kişisel verileriniz yurt dışına, KVKK&apos;nın 9.
          maddesine ve Kişisel Verilerin Yurt Dışına Aktarılmasına İlişkin Usul ve Esaslar Hakkında Yönetmelik&apos;e
          uygun olarak uygun güvencelerden birinin mevcut olması veya arızi aktarım hallerinden birinin mevcut olması
          durumunda aktarılır.
        </Paragraph>
        <Paragraph>
          Web sitemiz, çerezlerin kullanım ömrü boyunca web sitemizle ilgili gezinme bilgilerini toplamalarına olanak
          tanıyan üçüncü taraf çerezleri (iletişim ajansı, analiz hizmetleri vb.) içerebilir. Bu çerezlerin üçüncü
          şahıslar tarafından saklanması ve kullanılması, bu üçüncü şahısların gizlilik politikalarına tabidir. Web
          sitemizdeki üçüncü taraf çerezlerinin amacı ve bu çerezlerle ilgili tercihlerinizi belirtebileceğiniz araçlar
          hakkında sizi bilgilendiririz.
        </Paragraph>
        <Table
          pagination={false}
          rowKey={(record) => record.id}
          columns={[
            {
              title: 'Kategori',
              dataIndex: 'guideline',
              key: 'guideline',
              render: (guideline) => (
                <Link to={guideline} external newTab>
                  RENAULT TARAFINDAN OLUŞTURULDU
                </Link>
              ),
            },
            { title: 'Amaç', dataIndex: 'type', key: 'type' },
            {
              title: 'Çerez sahibi',
              dataIndex: 'site',
              key: 'site',
            },
            {
              title: 'Saklama süresi',
              dataIndex: 'duration',
              key: 'duration',
            },
          ]}
          dataSource={[
            {
              id: 0,
              site: 'ONE TRUST',
              type: 'TEKNİK',
              guideline: 'https://www.onetrust.com/fr/cookie-policy/',
              duration: '6 AY',
            },
            {
              id: 1,
              site: 'RENAULT',
              type: 'TEKNİK',
              guideline: 'https://www.renault.fr/cookies.html',
              duration: 'OTURUM',
            },
            {
              id: 2,
              site: 'MATOMO',
              type: 'ANALİTİK',
              guideline: 'https://matomo.org/privacy-policy/',
              duration: '13 AY',
            },
            {
              id: 3,
              site: 'DYNATRACE',
              type: 'ANALİTİK',
              guideline: 'https://www.dynatrace.com/company/trust-center/privacy/',
              duration: 'OTURUM',
            },
            {
              id: 4,
              site: 'CONTENTSQUARE',
              type: 'ANALİTİK',
              guideline: 'https://contentsquare.com/fr-fr/privacy-center/cookie-policy/',
              duration: '13 AY',
            },
            {
              id: 5,
              site: 'GOOGLE',
              type: 'ANALİTİK',
              guideline: 'https://policies.google.com/technologies/cookies',
              duration: '13 AY',
            },
            {
              id: 6,
              site: 'YOUTUBE',
              type: 'SOSYAL AĞLAR',
              guideline: 'https://www.youtube.com/t/terms',
              duration: '6 AY',
            },
          ]}
        />
      </Section>
      <Section>
        <SectionHeader title={'5. RIZANIZ NASIL ALINIR?'} />
        <Paragraph>
          Web sitemizi ilk ziyaret ettiğinizde açılan çerez bilgilendirme şeridinden, çerezlerin kullanımını kabul
          etmeniz veya reddetmeniz veya bunlarla ilgili tercihler yapmanız istenir.
        </Paragraph>
        <Paragraph>
          Aşağıdaki özel aracımız üzerinden istediğiniz zaman rızanızı geri alabilir veya tercihlerinizi
          değiştirebilirsiniz (örneğin yalnızca belirli çerez türlerini kabul edebilirsiniz):{' '}
          <ManageCookiesButton $color={'brand_alt'}>
            <button id="ot-sdk-btn" className="ot-sdk-show-settings">
              SEÇİMLERİMİ YÖNET
            </button>
          </ManageCookiesButton>
          .
        </Paragraph>
        <Paragraph>
          Yönetmelikler uyarınca web sitesinin çalışması için gerekli olan çerezlerin sizin rızanıza tabi olmadığını ve
          bu nedenle çerez yönetim aracımızda devre dışı bırakılamayacağını lütfen unutmayın. Tarayıcı ayarlarınızı
          değiştirerek (aşağıdaki &quot;çerezler nasıl reddedilir&quot; bölümünü takip ederek) çerez kullanımını
          engelleyebilirsiniz, ancak bu durumda web sitesindeki deneyiminizin kalitesi düşebilir.
        </Paragraph>
      </Section>
      <Section>
        <SectionHeader title={'6. RIZANIZ NE KADAR SÜRE SAKLANIR?'} />
        <Paragraph>
          Web sitemizdeki çerezlerin tamamını veya bir kısmını kabul ettiğinizde veya reddettiğinizde tercihleriniz
          kaydedilir (ve tercihlerinizin kaydını tutarız) ve en fazla 6 ay süreyle saklanır. Tercihlerinizin bu şekilde
          saklanması sayesinde, saklama süresi boyunca tercihleriniz kayıtlı olacağı için daha sonra web sitemizi
          ziyaret ettiğinizde çerezlerle ilgili olarak sizden tekrar bir işlem yapmanızı talep etmeyiz.
        </Paragraph>
        <Paragraph>
          Bu sürenin bitiminden sonra sizden tekrar çerez kullanımına izin vermenizi veya reddetmenizi isteyeceğiz.
        </Paragraph>
      </Section>
      <Section>
        <SectionHeader title={'7. ÇEREZLERİ NASIL YÖNETEBİLİRİM?'} />
        <SectionHeader title={'İtiraz hakkımı nasıl kullanabilirim?'} underline />
        <Paragraph>
          Çerezlerin cihazınızda saklanmasını veya okunmasını istemiyorsanız, çerez kullanımına itiraz ettiğinizi
          kaydetmemizi sağlamak için cihazınıza bir ret çerezi yerleştirilir. Bu çerez reddini silerseniz, artık
          çerezlerin kullanımını ve saklanmasını reddettiğinizi anlayamayız.
        </Paragraph>
        <Paragraph>
          Çerezleri yönetmek için kullanımlarını engelleme ve/veya silme dahil olmak üzere çeşitli seçenekleriniz
          vardır.
        </Paragraph>
        <SectionHeader title={'Çerez Yöneticisi'} underline />
        <Paragraph>
          Bu sitede saklanan ve/veya kullanılan çerezleri yönetebilmenizi sağlamak için bir çerez yöneticisi mevcuttur.
          Aşağıdaki linkte tıklayarak istediğiniz zaman yapılandırıcıya erişebilir ve ilgili çerezin türüne bağlı olarak
          tercihlerinizi değiştirebilirsiniz.
        </Paragraph>
        <SectionHeader title={'Tarayıcı ayarları'} underline />
        <Paragraph>Çerezleri tarayıcınız üzerinden de yönetebilirsiniz.</Paragraph>
        <Paragraph>
          Tarayıcıların çoğu varsayılan olarak çerezleri kabul edecek şekilde ayarlanmıştır, ancak dilerseniz tüm
          çerezleri kabul etmeyi veya reddetmeyi veya geldikleri adrese bağlı olarak hangi çerezleri kabul edeceğinizi
          seçebilirsiniz. Ayrıca tarayıcınızı kullanarak çerezleri cihazınızdan düzenli olarak silebilirsiniz.
        </Paragraph>
        <Paragraph>
          Ancak, çeşitli cihazlarınızdaki (tabletler, akıllı telefonlar, bilgisayarlar vb.) tüm tarayıcıları ayarlamayı
          unutmayın.
        </Paragraph>
        <Paragraph>
          Her tarayıcının çerezleri ve tercihlerinizi yönetmek için farklı bir ayarı vardır. Çerez tercihlerinizi nasıl
          değiştireceğiniz tarayıcınızın yardım menüsünde açıklanmıştır. Örn.:
        </Paragraph>
        <Paragraph align={'start'}>
          <Ul>
            <Li>
              Internet Explorer™ için:{' '}
              <Link external newTab to={'https://windows.microsoft.com/fr-FR/windows-vista/Block-or-allow-cookies'}>
                https://windows.microsoft.com/fr-FR/windows-vista/Block-or-allow-cookies
              </Link>{' '}
              ;
            </Li>
            <Li>
              Safari™ için:{' '}
              <Link external newTab to={'https://support.apple.com/fr-fr/safari'}>
                https://support.apple.com/fr-fr/safari
              </Link>{' '}
              ;
            </Li>
            <Li>
              Chrome™ için:{' '}
              <Link external newTab to={'https://support.google.com/chrome/answer/95647?hl=en&hlrm=en'}>
                https://support.google.com/chrome/answer/95647?hl=en&hlrm=en
              </Link>{' '}
              ;
            </Li>
            <Li>
              Firefox™ için:{' '}
              <Link
                external
                newTab
                to={'https://support.mozilla.org/en-US/kb/clear-cookies-and-website-data-single-domain-android'}
              >
                https://support.mozilla.org/en-US/kb/clear-cookies-and-website-data-single-domain-android
              </Link>{' '}
              ;
            </Li>
            <Li>
              Opera™ için:{' '}
              <Link external newTab to={'https://help.opera.com/Windows/10.20/en/cookies.html'}>
                https://help.opera.com/Windows/10.20/en/cookies.html.
              </Link>
            </Li>
          </Ul>
        </Paragraph>
        <SectionHeader title={'İtirazda bulunmak için yayımcı modülleri'} underline />
        <Paragraph>
          Doğrudan çerez sahibinin sayfasına giderek bazı üçüncü taraf çerezlerini devre dışı bırakmayı seçebilirsiniz.
          Örneğin:
        </Paragraph>
        <Paragraph align={'start'}>
          <Ul>
            <Li>
              Google Analytics çerezlerini devre dışı bırakmak için şu sayfaya gidin:{' '}
              <Link external newTab to={'https://tools.google.com/dlpage/gaoptout?hl=fr'}>
                https://tools.google.com/dlpage/gaoptout?hl=fr
              </Link>{' '}
              ;
            </Li>
            <Li>
              intelliAd çerezlerini devre dışı bırakmak için şu sayfaya gidin:{' '}
              <Link external newTab to={'https://login.intelliad.com/optout.php'}>
                https://login.intelliad.com/optout.php
              </Link>{' '}
              ;
            </Li>
            <Li>
              Adobe çerezlerini devre dışı bırakmak için şu sayfaya gidin:{' '}
              <Link external newTab to={'https://www.adobe.com/uk/privacy/opt-out.html'}>
                https://www.adobe.com/uk/privacy/opt-out.html
              </Link>{' '}
              ;
            </Li>
          </Ul>
        </Paragraph>
        <SectionHeader title={'Pazarlama itirazlarına yönelik platformlar'} underline />
        <Paragraph>
          Çeşitli profesyonel reklam platformları, bu platformlara üye olan şirketlerin kullandığı çerezleri
          reddetmenize veya kabul etmenize de olanak tanır. Bu merkezi mekanizmalar, reklamların görüntülenmesini
          engellemez; yalnızca reklamların ilgi alanlarınıza göre uyarlanmasına olanak tanıyan çerezlerin kurulumunu
          engeller.
        </Paragraph>
        <Paragraph>
          Örneğin cihazınıza çerezlerin yüklenmesini önlemek için{' '}
          <Link to={'https://www.youronlinechoices.com'} external newTab>
            www.youronlinechoices.com
          </Link>{' '}
          adresini ziyaret edebilirsiniz. Bu site, Avrupa kuruluşu olan EDAA&apos;nın (Avrupa Dijital Reklamcılık
          İttifakı) dijital reklamcılık uzmanları tarafından barındırılmaktadır ve Fransa&apos;da Fransa İnteraktif
          Reklamcılık Bürosu tarafından yönetilmektedir.
        </Paragraph>
        <Paragraph>
          Bu, bu platformda hangi şirketlerin kayıtlı olduğunu öğrenmenize ve tarayıcı bilgilerinize göre cihazınızda
          görüntülenebilecek reklamları uyarlamak için bu şirketler tarafından kullanılan çerezleri reddetmenize veya
          kabul etmenize olanak tanır:{' '}
          <Link to={'https://www.youronlinechoices.com/uk/your-ad-choices'} external newTab>
            https://www.youronlinechoices.com/uk/your-ad-choices
          </Link>{' '}
        </Paragraph>
        <Paragraph>
          Bu Avrupa platformu yüzlerce internet reklamcılığı uzmanı tarafından paylaşılmaktadır ve cihazınızda
          görüntülenebilecek reklamları cihazınızın tarama deneyimine göre uyarlamak için kullanılabilecek çerezleri
          reddetmeniz veya kabul etmeniz için merkezi bir arayüz sağlamaktadır.
        </Paragraph>
      </Section>
      <Section>
        <SectionHeader title={'8. DİĞER HAKLARINIZI NASIL KULLANABİLİRSİNİZ?'} />
        <Paragraph>
          KVKK&apos;nın 11. maddesi uyarınca, Şirketimize başvurarak kişisel verileriniz hakkında aşağıdaki konulara
          ilişkin taleplerde bulunabilirsiniz:
        </Paragraph>
        <Paragraph align={'start'}>
          <Ul>
            <Li>Kişisel verilerinin işlenip işlenmediğini öğrenme,</Li>
            <Li>Kişisel verileri işlenmişse buna ilişkin bilgi talep etme,</Li>
            <Li>Kişisel verilerinin işlenme amacı ve bunların amacına uygun kullanılıp kullanılmadığını öğrenme,</Li>
            <Li>Kişisel verilerinin yurt içinde veya yurt dışında aktarıldığı üçüncü kişileri öğrenme,</Li>
            <Li>
              Kişisel verilerinin eksik veya yanlış işlenmiş olması halinde bunların düzeltilmesini isteme ve bu
              kapsamda yapılan işlemin kişisel verilerin aktarıldığı üçüncü kişilere bildirilmesini isteme,
            </Li>
            <Li>
              Kişisel verilerinin işlenmesini gerektiren sebeplerin ortadan kalkması halinde bunların silinmesini, yok
              edilmesini veya anonim hale getirilmesini isteme ve bu kapsamda yapılan işlemin kişisel verilerin
              aktarıldığı üçüncü kişilere bildirilmesini isteme,
            </Li>
            <Li>
              İşlenen kişisel verilerinin münhasıran otomatik sistemler vasıtasıyla analiz edilmesi suretiyle veri
              sahibinin aleyhine bir sonucun ortaya çıkmasına itiraz etme,
            </Li>
            <Li>
              Kişisel verilerinin kanuna aykırı olarak işlenmesi sebebiyle zarara uğraması halinde zararın giderilmesini
              talep etme.
            </Li>
          </Ul>
        </Paragraph>
        <Paragraph>
          Tüm haklarınızı, talebinizi{' '}
          <Link to={'mailto:dpo@renault.com'} external>
            dpo@renault.com
          </Link>{' '}
          adresine göndererek kullanabilirsiniz. Şirketimiz, KVKK&apos;nın 13. maddesine uygun olarak, Veri Sorumlusuna
          Başvuru Usul ve Esasları Hakkında Tebliğ&apos;in &quot;Başvuru Usulü&quot; başlıklı 5. maddesi 2.fıkrasına
          uygun bulunması kaydıyla, başvuru taleplerinizi, talebin niteliğine göre ve en geç 30 (otuz) gün içinde
          ücretsiz olarak sonuçlandıracaktır. Talebin reddedilmesi halinde, ret nedeni/nedenleri tarafınıza yazılı
          olarak veya elektronik ortamda gerekçeleriyle bildirilir. Renault&apos;dan bir cevap veya tatmin edici bir
          yanıt gelmemesi halinde, yerel veri koruma makamınıza şikayette bulunabilirsiniz.
        </Paragraph>
      </Section>
      <Section>
        <SectionHeader title={'9. DEĞİŞİKLİKLER'} />
        <Paragraph>
          Muhtelif zamanlarda bu politikada değişiklikler yapabiliriz. Gerektiğinde sizi bilgilendireceğiz ve/veya
          onayınızı isteyeceğiz. Bu nedenle, en son sürümünü incelemek için web sitemizi her ziyaret edişinizde bu
          Politikaya bakmanızı öneririz.
        </Paragraph>
      </Section>
      <Flex justify={'flex-end'}>
        <Text type={'text'}>Son güncelleme: Ekim 2024</Text>
      </Flex>
      <MarginBox mt={90} />
    </Container>
  );
};
